<template>
  <span ref="trigger" class="text-body-1">...</span>
</template>

<script>
export default {
  name: 'ScrollTrigger',

  props: {
    options: {
      type: Object,
      default: () => ({
        root: null,
        threshold: '0',
      }),
    },
  },

  data: () => ({
    observer: null,
  }),

  mounted() {
    // console.log('components.scroll-trigger.mounted')

    this.observer = new IntersectionObserver((entries) => {
      this.handleIntersect(entries.shift(), this.options)
    })

    this.observer.observe(this.$refs.trigger)
  },

  destroyed() {
    this.observer && this.observer.disconnect()
  },

  methods: {
    handleIntersect(entry) {
      if (entry.isIntersecting) {
        this.$emit('triggerVisible')
        console.log('components.scroll-trigger.methods.is-intersecting')
      }
      if (!entry.isIntersecting) this.$emit('triggerInvisible')
    },
  },
}
</script>
